import { useReactMutation, getPostServicePromise } from '@invision/core';
import type { SecurityRetrieveSessionResponse } from 'invApi';

export const RETRIEVE_SESSION_MUTATION_KEY = 'retrieveSession';

export function useRetrieveSessionMutation() {
  return useReactMutation<SecurityRetrieveSessionResponse, {}>(
    [RETRIEVE_SESSION_MUTATION_KEY],
    () =>
      getPostServicePromise(
        { path: 'Security/RetrieveSession' },
        { payload: {}, faults: {} as never }
      ),
    {},
    {
      useLoadingIndicator: false // We handle loading at SessionGuard level
    }
  );
}
